var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('ListModal', {
    ref: "Modal",
    attrs: {
      "title": "Tasks",
      "load-items": _vm.loadTasks,
      "add-button": "",
      "item-key": "xid",
      "item-text": "title",
      "sortable": ""
    },
    on: {
      "add-item": _vm.addTask,
      "sort": _vm.sortTasks
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-btn', {
          staticClass: "float-left primary--text",
          attrs: {
            "text": ""
          },
          on: {
            "click": function click($event) {
              return _vm.editDuration(item);
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-1",
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-clock-outline")]), _vm._v(_vm._s(item.duration))], 1), _c('v-btn', {
          staticClass: "float-left",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function click($event) {
              return _vm.editTask(item);
            }
          }
        }, [_c('v-icon', {
          staticClass: "primary--text"
        }, [_vm._v("mdi-pencil")])], 1), _c('v-btn', {
          staticClass: "float-left",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function click($event) {
              return _vm.deleteTask(item);
            }
          }
        }, [_c('v-icon', {
          staticClass: "error--text"
        }, [_vm._v("mdi-trash-can")])], 1)];
      }
    }])
  }), _c('v-dialog', {
    attrs: {
      "value": _vm.edit.show,
      "persistent": "",
      "max-width": "600px",
      "scrollable": ""
    }
  }, [_c('v-card', {
    attrs: {
      "disabled": _vm.edit.loading,
      "loading": _vm.edit.loading
    }
  }, [_c('v-card-title', {
    staticClass: "primary white--text py-2"
  }, [_vm._v("Edit Task")]), _c('v-card-text', {
    staticStyle: {
      "height": "auto"
    }
  }, [_c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "label": "Title"
    },
    model: {
      value: _vm.edit.task.title,
      callback: function callback($$v) {
        _vm.$set(_vm.edit.task, "title", $$v);
      },
      expression: "edit.task.title"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "dense": "",
      "label": "Description",
      "counter": "",
      "maxlength": "255"
    },
    model: {
      value: _vm.edit.task.description,
      callback: function callback($$v) {
        _vm.$set(_vm.edit.task, "description", $$v);
      },
      expression: "edit.task.description"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    staticClass: "secondary",
    on: {
      "click": function click($event) {
        _vm.edit.show = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": _vm.edit_save
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }